import {timestampForFileName} from "../js/DateUtils";

export function createFileNameTimeStamp(d) {
    return timestampForFileName(d);
}